import axios from 'axios';
import Cookies from 'universal-cookie';
import history from '../routes/history';

export default class ApiClient {

    post(controllerName, actionName, data) {

        var cookies = new Cookies();

        var instance = axios.create({
            baseURL: 'https://api.monitor.meseems.com.br/',
            headers: {
                ControllerName: controllerName,
                ActionName: actionName,
                AuthenticationToken: cookies.get('AuthenticationToken')
            }
        });

        window.page.loader.show();

        var promise = instance.post('MeSeems_Monitor_Api', data);

        promise.then(function() {
            window.page.loader.hide();
        }).catch(function(error) {
            window.page.loader.hide();
            if (error.response.data.errorMessage.indexOf('InvalidAuthenticationTokenException') > -1 || 
                error.response.data.errorMessage.indexOf('ExpiredAuthenticationTokenException') > -1 || 
                error.response.data.errorMessage.indexOf('UnauthorizedAccessException') > -1)
                history.push('/');
        });

        return promise;

    }

}


// WEBPACK FOOTER //
// ./src/stores/ApiClient.js